<template>
    <div class="container">
        <v-card class="article-card">
            <div class="title">
                <i class="fas fa-trophy" style="color: #ffb800;"></i>
                <span>战队排名 TOP 10</span>
                <router-link to="/valvestandings?tab=ranking" class="more">更多</router-link>
            </div>

            <div class="rank-wrapper">
                <div class="rank-col">
                    <div class="team-item" 
                         v-for="(item, index) in leftTeams" 
                         :key="'left-' + index"
                         @click="handleClick(item.teamName)"> <span class="rank-idx" :class="'top-' + item.standing">{{ item.standing }}</span>
                        <span class="team-name">{{ item.teamName }}</span>
                    </div>
                </div>

                <div class="rank-col">
                    <div class="team-item" 
                         v-for="(item, index) in rightTeams" 
                         :key="'right-' + index"
                         @click="handleClick(item.teamName)"> <span class="rank-idx">{{ item.standing }}</span>
                        <span class="team-name">{{ item.teamName }}</span>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import { getStandingsTop10 } from '@/api/standings'

export default {
    data() {
        return {
            teams: []
        };
    },
    computed: {
        leftTeams() { return this.teams.slice(0, 5); },
        rightTeams() { return this.teams.slice(5, 10); }
    },
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                const responseData = await getStandingsTop10();
                this.teams = responseData.data;
            } catch (error) {
                console.error("获取排名失败", error);
            }
        },
        // 修改后的点击跳转逻辑
        handleClick(name) {
            if (!name) return;
            this.$router.push({ 
                path: '/valvestandings', 
                query: { 
                    team: name,      // 传递战队名
                    tab: 'trend'     // 强制跳转到“排名走势”面板
                } 
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    padding: 0;

    .article-card {
        margin-top: 20px;
        border-radius: 10px;
        width: 300px;
        /* 严格固定宽度 */
        background-color: var(--background-color);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        &:hover {
            box-shadow: 5px 4px 8px 6px rgba(7, 17, 27, .06);
            transition: all .3s;
        }

        .title {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid var(--border-line);
            padding: 0 12px;

            .more {
                float: right;
                font-size: 12px;
                color: gray;
                text-decoration: none;
            }

            i {
                margin-right: 8px;
            }

            span {
                font-size: 15px;
                font-weight: 700;
                color: var(--box-title_color);
            }
        }

        .rank-wrapper {
            display: flex;
            padding: 8px 10px;
            /* 减小内距，防止文字受挤压 */
            gap: 8px;
            /* 设定列间距，使内容向中间聚拢 */

            .rank-col {
                flex: 1;
                overflow: hidden;

                .team-item {
                    display: flex;
                    align-items: center;
                    padding: 5px 2px;
                    cursor: pointer;
                    border-radius: 4px;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.03);
                    }

                    .rank-idx {
                        width: 14px;
                        font-size: 12px;
                        font-weight: bold;
                        color: #999;
                        flex-shrink: 0;
                        text-align: center;

                        &.top-1 {
                            color: #ef5151;
                        }

                        &.top-2 {
                            color: #ff7e3d;
                        }

                        &.top-3 {
                            color: #ffb800;
                        }
                    }

                    .logo-box {
                        width: 18px;
                        height: 18px;
                        margin: 0 6px;
                        flex-shrink: 0;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }

                        .empty-logo {
                            width: 100%;
                            height: 100%;
                            background: #eee;
                            border-radius: 3px;
                        }
                    }

                    .team-name {
                        font-size: 14px;
                        /* 12px 在窄列布局中视觉效果最好 */
                        color: var(--text-color);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        flex: 1;
                    }
                }
            }
        }
    }
}
</style>